/* Version: 3.5.137 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { safeRest, noop } from '../../utils/functions.js';
import handle from '../../utils/handle.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { RadioWrapper } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "name", "disabled", "error", "customStyle", "onChange"];
var RadioButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$name = _ref.name,
    name = _ref$name === undefined ? '' : _ref$name,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === undefined ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === undefined ? false : _ref$error,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      radioStyle: {}
    } : _ref$customStyle,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === undefined ? noop : _ref$onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    radioStyle = _safeCustomStyle.radioStyle;
  return /*#__PURE__*/jsx(RadioWrapper, _objectSpread({
    id: id,
    type: "radio",
    name: name,
    disabled: disabled,
    error: error,
    onChange: handle(onChange),
    radioStyle: radioStyle,
    theme: theme,
    ref: ref
  }, safeProps));
});
process.env.NODE_ENV !== "production" ? RadioButton.propTypes = {
  /** ID for the radiobutton */
  id: PropTypes.string.isRequired,
  /** name for the radiobutton */
  name: PropTypes.string,
  /** Disable the radiobutton */
  disabled: PropTypes.bool,
  /** Show error state for radio button */
  error: PropTypes.bool,
  /** Callback to be called when the checkbox changes */
  onChange: PropTypes.func,
  /** Style overrides */
  customStyle: PropTypes.shape({
    radioStyle: PropTypes.object
  })
} : undefined;
process.env.NODE_ENV !== "production" ? RadioButton.displayName = 'RadioButton' : undefined;

export { RadioButton as default };
